/* eslint-disable prettier/prettier */
/* eslint-disable no-console */

import request from '@/utils/request'
import qs from 'qs'

//========= 检查
//甲方单位
export const queryPartyaNames = () => {
  return request({
    url: '/inspect/queryPartyaNames',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: {}
  })
}
//租赁单位
export const queryUnit = (postData) => {
  return request({
    url: '/inspect/queryUnit',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//工地
export const queryProjectName = (postData) => {
  return request({
    url: '/inspect/queryProjectName',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 查看设备总数
export const getInpectDeviceCount = (postData) => {
  return request({
    url: '/inspect/getInpectDeviceCount',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 查看设备平均分
export const getDeviceAveScore = (postData) => {
  return request({
    url: '/inspect/getDeviceAveScore',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据类型统计设备数量
export const queryDeviceByType = (postData) => {
  return request({
    url: '/inspect/queryDeviceByType',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据隐患查看不同等级的问题数量
export const queryScoreByLevel = (postData) => {
  return request({
    url: '/inspect/queryScoreByLevel',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据不同设备隐患查看不同等级的问题数量
export const queryScoreByLevel_s = (postData) => {
  return request({
    url: '/inspect/queryScoreByLevelThird',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 多维度统计得分
export const queryScore = (postData) => {
  return request({
    url: '/inspect/queryScore',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据月份统计数量
export const queryDeviceByMonth = (postData) => {
  return request({
    url: '/inspect/queryDeviceByMonth',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

//设备扣分统计
export const inspectQuestionInfo = (postData) => {
  return request({
    url: '/inspect/inspectQuestionInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//检查台账
export const listDeviceQuestion = (postData) => {
  return request({
    url: '/account/listDeviceQuestion',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//检查单设备导出
export const deviceExport = (postData) => {
  return request({
    url: '/account/deviceExportByApplyId',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(postData),
    responseType: 'blob'
  })
}
//检查台账导出下载
export const deviceQuestionExport = (postData) => {
  return request({
    url: '/account/deviceQuestionExport',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(postData),
    responseType: 'blob'
  })
}
// 根据年份查每个季度的分数
export const queryScoreByYear = (postData) => {
  return request({
    url: '/inspectChart/queryScoreByYear',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 一段时间内各分段设备数量及占比
export const queryDeviceCount = (postData) => {
  return request({
    url: '/inspectChart/queryDeviceCount',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 单种设备各品牌检查数量，平均得分图（塔机，施工升降机）
export const queryInspectProductionCount = (postData) => {
  return request({
    url: '/inspectChart/queryInspectProductionCount',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 工程平均得分，设备数量，危险设备数表
export const queryScoreCountByProjectName = (postData) => {
  return request({
    url: '/inspectChart/queryScoreCountByProjectName',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 单种设备各责任单位平均得分，检查数量，危险设备数（塔机，电梯）
export const queryInspectUnitCount = (postData) => {
  return request({
    url: '/inspectChart/queryInspectUnitCount',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看安装单位工程明细
export const queryInspectUnitCountInfo = (postData) => {
  return request({
    url: '/inspectChart/queryInspectUnitCountInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看生产厂家工程明细
export const queryInspectProductionCountInfo = (postData) => {
  return request({
    url: '/inspectChart/queryInspectProductionCountInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//月度设备数量/分值
export const queryDeviceAndScoreByMonth = (postData) => {
  return request({
    url: '/inspect/queryDeviceAndScoreByMonth ',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
